export const bearerTokenKey = 'bearerToken';
export const activeProfileKey = 'ARB/activeProfileId';
